import React from 'react';
import ArrowBack from '../../../assets/icons/ArrowBack';
import './ArrowBack.scss';

const ArrowBackComponent = ({onClick}) => {
    return (
        <div className={'v2-arrow-back-container flex-aligned-justified-center'} onClick={onClick}>
            <ArrowBack width={'14'} height={'14'} color={'primary-500'}/>
        </div>

    );
};
export default ArrowBackComponent;
